<template>
    <div class="height-100">
        <gofix-card title="Supplier Info" class="fixHeight">
            <template slot="gofixCard:right_header">
                <template v-if="!IsReadOnly">
                    <button
                        v-if="$checkRole(this.$accessModule.order_tabs.main_info, 'update') && checkConditionUpdateSupplier()"
                        class="icon-button" @click="open = true"><img width="20" src="img/iconPencil.png" alt="" /></button>
                </template>
            </template>
            <b-row>
                <b-col md="7">
                    <gofix-text-field class="mb-3" label="Supplier Company" oneline>{{Item.supplier_name ? Item.supplier_name : null}}</gofix-text-field>
                </b-col>
                <b-col md="5">
                    <!-- <gofix-text-field class="mb-3" label="Creditor Code" oneline>{{(Item.get_supplier  ? Item.get_supplier.creditor_code : '')+(Item.get_supplier && Item.get_supplier.get_debtor_code && Item.get_supplier.get_debtor_code.source_description ? (' - ' + Item.get_supplier.get_debtor_code.source_description) : '')}}</gofix-text-field> -->
                    <gofix-text-field class="mb-3" label="Creditor Code" oneline>{{ getCreditorCode }}</gofix-text-field>
                </b-col>
                <b-col md="12">
                    <gofix-text-field label="Contact Person" oneline>
                        <div v-if="Item.contact_person">
                            <span> {{Item.contact_person}}</span>
                        </div>
                    </gofix-text-field>
                </b-col>
            </b-row>
        </gofix-card>
        <b-modal 
            :no-close-on-backdrop="true"
            id="modal-SupplierInfo" title="Supplier Info"
            hide-footer :centered="true"
            ref="modal-SupplierInfo"
            v-model="open"
            @hidden="hiddenModal"
            @shown="modalShown">
            <b-form v-bind:class="{'run-loading':loading}">
                <b-row>
                    <b-col md="12">
                        <gofix-form-supplier 
                            label="Supplier Name" class="m-0"
                            :contract-id="this.Item.contract_id"
                            :property-id="this.Item.service_location"
                            :service-category-id="this.Item.service_category_id"
                            v-model="data.get_supplier">
                        </gofix-form-supplier>
                        <div class="boxInfoSupplier info-code" v-if="data.get_supplier">
                            <div class="content-info">
                                <label class="width-131">Creditor code</label>
                                <!-- <div class="content">{{ (data.get_supplier  ? data.get_supplier.creditor_code : null)+(data.get_supplier && data.get_supplier.get_debtor_code && data.get_supplier.get_debtor_code.source_description ? (' - ' + data.get_supplier.get_debtor_code.source_description) : '')}}</div> -->
                                <div class="content">{{ getCreditorCodeModal }}</div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="boxInfoSupplier" v-if="data.get_supplier && data.get_supplier.mailing_address">
                    <b-row>
                        <b-col md="12">
                            <label class="title">Mailing contact</label>
                            <div class="content-info">
                                <label>Name</label>
                                <div class="content">{{ (data.get_supplier && data.get_supplier.mailing_address) ? data.get_supplier.mailing_address.display_name : '-'}}</div>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <div class="content-info">
                                <label>Email</label>
                                <div class="content">{{ (data.get_supplier && data.get_supplier.mailing_address) ? data.get_supplier.mailing_address.email : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <div class="content-info">
                                <label class="width-131">Phone number</label>
                                <div class="content">{{ (data.get_supplier && data.get_supplier.mailing_address) ? data.get_supplier.mailing_address.primary_phone : '-'}}</div>
                            </div>
                        </b-col>
                        <b-col md="12">
                            <div class="content-info">
                                <label>Address</label>
                                <div class="content">{{data.get_supplier.mailing_address.display_address}} </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="boxInfoSupplier" v-if="data.get_supplier">
                    <b-row>
                        <b-col md="12">
                            <label class="title">billing contact</label>
                            <div class="content-info">
                                <label>Name</label>
                                <div class="content">{{ (data.get_supplier && data.get_supplier.billing_address) ? data.get_supplier.billing_address.display_name : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <div class="content-info">
                                <label>Email</label>
                                <div class="content">J{{ (data.get_supplier && data.get_supplier.billing_address) ? data.get_supplier.billing_address.email : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <div class="content-info">
                                <label class="width-131">Phone number</label>
                                <div class="content">{{(data.get_supplier && data.get_supplier.billing_address) ? data.get_supplier.billing_address.primary_phone : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col md="12">
                            <div class="content-info">
                                <label>Address</label>
                                <div class="content" v-if="data.get_supplier && data.get_supplier.billing_address">
                                    {{ data.get_supplier.billing_address.display_address}}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveData" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'supplier-info',
        components: {},
        data () {
            return {
                open: false,
                loading:false,
                data: {
                    get_supplier : null
                },
                suppliers:[],
                tiers: null,
                tierLevel: 1,
                wo_status:[
                    'Issued',
                ]
            }
        },
        watch: {
            "Item.contract_id" : function (val) {
                this.getSupplier();
            }
        },
        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
            getCreditorCode() {
                var creditor_code = '';
                var source_description = '';
                if(this.Item.get_supplier && this.Item.get_supplier.vendor_linking_creditor_code) {
                    if(this.Item.client_contract && this.Item.client_contract.finance_company && this.Item.client_contract.finance_company.company && this.Item.client_contract.finance_company.company.id) {
                        const arrTmp = this.Item.get_supplier.vendor_linking_creditor_code.filter(item => item.coa_companie_id == this.Item.client_contract.finance_company.company.id);
                        if(arrTmp.length) {
                            creditor_code = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_code ? arrTmp[0].creditor_code.source_code : '';
                            source_description = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_description ? (" - " + arrTmp[0].creditor_code.source_description) : '';
                        }
                    }
                }

                if(creditor_code) return creditor_code + source_description;
                return;
            },
            getCreditorCodeModal() {
                var creditor_code = '';
                var source_description = '';
                if(this.data.get_supplier && this.data.get_supplier.vendor_linking_creditor_code) {
                    if(this.Item.client_contract && this.Item.client_contract.finance_company && this.Item.client_contract.finance_company.company && this.Item.client_contract.finance_company.company.id) {
                        const arrTmp = this.data.get_supplier.vendor_linking_creditor_code.filter(item => item.coa_companie_id == this.Item.client_contract.finance_company.company.id);
                        if(arrTmp.length) {
                            creditor_code = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_code ? arrTmp[0].creditor_code.source_code : '';
                            source_description = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_description ? (" - " + arrTmp[0].creditor_code.source_description) : '';
                        }
                    }
                }

                if(creditor_code) return creditor_code + source_description;
                return;
            }
        },
        created() {
            if(this.Item) {
                this.getSupplier();
            }
        },
        methods: {
            /*--- Get data -----------------------------------------------------------------*/
            async saveData(){
                if(this.loading) return;
                this.loadings = true;
                let data = {
                    supplier_id : this.data.get_supplier.id || null,
                    log:'supplier_info'
                };
                this.$store.dispatch("OrderController/updateItem",{ id:this.Item.id, data: data })
                    .then(response => {
                        this.open = false;
                        this.loading = false;
                        this.$alertNotification(this.$notificationV2('editing', 'supplier'));                 
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
            },

            /*--- Get data -----------------------------------------------------------------*/
            showMoreSupplier(){
              switch (this.tierLevel) {
                  case 1:
                    this.suppliers = this.suppliers.concat(this.tiers.tier_2);
                    this.tierLevel = 2;
                    break;
                  case 2:
                    this.suppliers = this.suppliers.concat(this.tiers.tier_3);
                    this.tierLevel = 3;
                    break;
              }
            },
            getSupplier(){
                this.$store.dispatch("OrganizationController/getRelateSupplier",{
                    contract_id:this.Item.contract_id,
                    order_id: this.Item.id,
                    filter:null
                })
                    .then(response => {
                        this.tiers = response;
                        if(response.tier_1){
                            this.suppliers = response.tier_1;
                            this.tierLevel = 1;
                        }else if(response.tier_2){
                            this.suppliers = response.tier_2;
                            this.tierLevel = 2;
                        }else if(response.tier_3){
                            this.suppliers = response.tier_3;
                            this.tierLevel = 3;
                        }
                    })
                    .catch( err => {
                        console.log(err)
                    })
            },

            /*--- Shown Modals -----------------------------------------------------------------*/
            modalShown(){
                this.data.get_supplier = this.Item.get_supplier;
            },
            hiddenModal(){
                if(this.tiers.tier_1){
                    this.suppliers = this.tiers.tier_1;
                    this.tierLevel = 1;
                }else if(this.tiers.tier_2){
                    this.suppliers = this.tiers.tier_2;
                    this.tierLevel = 2;
                }else if(this.tiers.tier_3){
                    this.suppliers = this.tiers.tier_3;
                    this.tierLevel = 3;
                }
            },
            checkConditionUpdateSupplier(){
                if(this.Item){
                    if(this.wo_status.includes(this.Item.order_status)){
                        return true;
                    }
                    if(this.Item.client_contract.settings && 
                    this.Item.client_contract.settings.is_allow_change_supplier_after_wo_approved){
                        return true;
                    }
                    return false;
                }
                return false;
            }
        },
    }
</script>